// @ts-check
// The profile's Program Start date, saved from its inline editor (moved from app.js window.saveProgramStartDate).

import { clients } from '../state.js';
import { updateClient } from '../clients.js';
import { showToast } from '../utils.js';

/**
 * Save the Program Start date typed in the profile's editor.
 * @param {string} clientId @param {{ render: () => void }} o render: the profile, drawn again
 */
export async function saveProgramStartDate(clientId, { render }) {
  const inp = /** @type {HTMLInputElement|null} */ (document.getElementById('cp-ps-input'));
  if (!inp) return;
  const dateVal = inp.value || null; // YYYY-MM-DD or null
  try {
    // Saved first, then shown: updateClient compares with the client as it is (a waiting program refuses new dates,
    // the final review 10/17), and a refused date never shows as saved
    await updateClient(clientId, {
      programStartDate:       dateVal,
      programStartDateSource: 'manual',
    });
    const c = /** @type {any} */ (clients.find(x => x.id === clientId));
    if (c) {
      c.programStartDate       = dateVal;
      c.programStartDateSource = 'manual';
    }
    render();
    showToast('Program start date saved.', 'success');
  } catch (err) {
    showToast('Error saving date: ' + /** @type {any} */ (err).message, 'error');
  }
}
